import React, { Component } from 'react';
import HalfScreenTextParent from './HalfScreenTextParent';
import CenteredTextTest from './CenteredTextTest';
import Fade from 'react-reveal/Fade';
import TiArrowRight from 'react-icons/lib/ti/arrow-right';
import FlexCenter from './FlexCenter';
import rightarrow from './rightarrow.png';
import { Link } from 'react-router-dom';

class FurnishedLiving extends Component {
  constructor(){
    super()
    this.state = {
      flag: false
    }
  }
  render(){
    var contentObj = furnishedLivingObj
    if(this.props.content === "gallery"){
      contentObj = galleryObj
    }

    return (
      <div className="intro-text-frame">
        <div className="col-lg-2 col-md-1 col-sm-1 col-xs-1"></div>
        <div style={{height: '100%', padding: '2em 0em'}} className="col-lg-8 col-md-10 col-sm-10 col-xs-10">
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <div>
              <Fade top>
                <div className="ourStandardH1 formHeader">{this.props.title}</div>
              </Fade>
              <Fade bottom>
                <div className="furnishedLivingBodyText">{this.props.text1}</div>
                <div className="furnishedLivingBodyText">{this.props.text2}</div>
              </Fade>
            </div>
        </div>
        </div>
        <div className="col-lg-2 col-md-1 col-sm-1 col-xs-1"></div>
      </div>
    )
  }
}

export default FurnishedLiving;


var furnishedLivingObj = {
  title: 'Furnished Living',
  text1: 'Our luxury furnished apartments are situated in the finest areas of West Hollywood and Santa Monica. We offer long-term rentals (30 days minimum) in our studio, one-bedroom, and two-bedroom apartments. Each unit is finished with fine appliances and detailed decorations. We balance style and comfort to provide a home away from home.' ,
  text2: 'Our properties are situated in the best parts of West Hollywood and Santa Monica. In West Hollywood we are short walk to Robertson and 3rd. In Santa Monica, you can find us on Montana Ave, just steps to the beach. We provide everything you need on your long-term stay in Los Angeles to make sure you will enjoy your stay.',
  buttonText: 'Explore Floor Plans'
}

var galleryObj = {
  title: 'Luxury & Comfort',
  text1: 'Our luxury furnished apartments are situated in the finest areas of West Hollywood and Santa Monica. We offer long-term rentals (30 days minimum) in our studio, one-bedroom, and two-bedroom apartments. Each unit is finished with fine appliances and detailed decorations. We balance style and comfort to provide a home away from home.' ,
  text2: 'Our furnished units are located in walking distance to anything you may need. In West Hollywood, we are just off Robertson, and in Santa Monica we are steps from the beach on Montana Ave. This is further dummy information that CLIENT may want to put here.',
  buttonText: 'Explore Gallery'
}



// WEBPACK FOOTER //
// ./src/IntroText.js